module.exports = __webpack_public_path__ + "img/banner1.039e60f.png";